import { isAxiosError } from "axios";

export function getErrorDetails(error: unknown): string {
  if (isAxiosError(error)) {
    return JSON.stringify(
      {
        name: error.name,
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        method: error.config?.method,
        url: error.config?.url,
        data: error.response?.data,
        stack: error.stack,
      },
      null,
      2,
    );
  }

  if (error instanceof Error) {
    return [error.toString(), error.stack].filter(Boolean).join("\n\n");
  }

  try {
    return JSON.stringify(error, null, 2);
  } catch {
    return String(error);
  }
}
